import { get } from 'common/utils/request';
export var checkShowBalanceApi = function () {
    return get('/employees/show-balances');
};
